// src/constants/action-types/preview.js
export const UPDATE_PREVIEW_DATA = 'UPDATE_PREVIEW_DATA';
export const RESET_PREVIEW_DATA = 'RESET_PREVIEW_DATA';
export const UPDATE_PREVIEW_MEDIA = 'UPDATE_PREVIEW_MEDIA';
export const UPDATE_PREVIEW_CONTENT = 'UPDATE_PREVIEW_CONTENT';
export const SET_PREVIEW_PLATFORM = 'SET_PREVIEW_PLATFORM';
export const SET_PLATFORM_DATA = 'SET_PLATFORM_DATA';
export const SET_ENGAGEMENT_DATA = 'SET_ENGAGEMENT_DATA';
export const UPDATE_REACTIONS = 'UPDATE_REACTIONS';
export const ADD_COMMENT = 'ADD_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const UPDATE_ANALYTICS = 'UPDATE_ANALYTICS';
export const UPDATE_COMMENT_LIKES = 'UPDATE_COMMENT_LIKES';
export const TOGGLE_REACTION = 'TOGGLE_REACTION';
export const UPDATE_IMPRESSIONS = 'UPDATE_IMPRESSIONS';
export const ADD_SHARE = 'ADD_SHARE';
export const SET_POST_VISIBILITY = 'SET_POST_VISIBILITY';
export const UPDATE_POST_STATS = 'UPDATE_POST_STATS';






